import React, { FC, memo, PropsWithChildren, useState } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { ErrorFallbackContent } from './errorFallbackContent';

export interface ErrorBoundaryWrapperProps extends PropsWithChildren {
  source?: string;
}

export const ErrorBoundaryWrapper: FC<ErrorBoundaryWrapperProps> = memo(
  ({ children, source }) => {
    const [errorInfo, setErrorInfo] = useState<React.ErrorInfo | null>(null);

    return (
      <ErrorBoundary
        onError={(error, info) => {
          setErrorInfo(info);
          console.error(
            `[ErrorBoundaryWrapper] Caught error from ${source || 'Unknown'}`,
            error,
            info,
          );
        }}
        fallbackRender={props => (
          <ErrorFallbackContent
            {...props}
            source={source}
            errorInfo={errorInfo}
          />
        )}
      >
        {children}
      </ErrorBoundary>
    );
  },
);
